import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./component/Navbar";
import Home from "./pages/home";
import Meditate from "./pages/meditate";
import Meetups from "./pages/meetups";
import Programs from "./pages/programs";
import Team from "./pages/team";
import WhatsAppButton from "./component/WhatsAppButton";
import FacebookButton from "./component/FacebookButton";
import InstagramButton from "./component/InstagramButton";
import GoogleReviewsButton from "./component/GoogleReviewsButton";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/Programs" element={<Programs />} />
        <Route path="/Meditate" element={<Meditate />} />
        <Route path="/Team" element={<Team />} />
        <Route path="/Meetups" element={<Meetups />} />
      </Routes>
      <nav className="floating-social-links" aria-label="Contact and social links">
        <WhatsAppButton />
        <FacebookButton />
        <InstagramButton />
        <GoogleReviewsButton />
      </nav>
    </Router>
  );
}
export default App;
